import gql from "graphql-tag";

export const SEND_MULTIPLE_TO_BACKLOG = gql`
  mutation ($input: sendMultipleToBacklogInput) {
    sendMultipleToBacklog(input: $input)
  }
`;
